<template>
    <div>
        <div v-if="isLoading" class="global-loading-overlay">
            <div class="global-loading-box">
                <div class="global-spinner"></div>
                <div class="global-loading-text">Memuat data...</div>
            </div>
        </div>

        <div v-if="showFilter" class="row mt-3">
            <h4 class="mb-3">Pencarian Data</h4>

            <div
                v-for="(filterConfig, index) in filterConfigs"
                :key="index"
                :class="filterConfig.colClass"
            >
                <div class="mb-3 row">
                    <label
                        :for="filterConfig.id"
                        class="col-sm-4 col-form-label text-end"
                    >
                        {{ filterConfig.label }}
                    </label>

                    <div class="col-sm-8" v-if="!filterConfig.component">
                        <component
                            :is="filterConfig.component || 'input'"
                            :type="filterConfig.type || 'text'"
                            :name="filterConfig.id"
                            :id="filterConfig.id"
                            class="form-control"
                            :value="filter[filterConfig.field]"
                            @input="updateFilter(filterConfig.field, $event)"
                            v-bind="filterConfig.props || {}"
                        />
                    </div>

                    <div class="col-sm-8" v-else>
                        <DropDownYear
                            :modelValue="filter[filterConfig.field]"
                            @update:modelValue="
                                updateFilter(filterConfig.field, $event)
                            "
                        />
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-3">
                <div class="mb-3">
                    <div class="d-flex gap-1 align-items-center flex-wrap">
                        <button
                            type="button"
                            class="btn btn-sm btn-danger"
                            @click="resetFilters"
                            :disabled="isLoading"
                        >
                            <i class="fa fa-refresh"></i>
                            Reset
                        </button>

                        <button
                            type="button"
                            class="btn btn-sm btn-primary"
                            @click="refreshTable"
                            :disabled="isLoading"
                        >
                            <i
                                class="fa"
                                :class="
                                    isLoading
                                        ? 'fa-spinner fa-spin'
                                        : 'fa-search'
                                "
                            ></i>

                            {{ isLoading ? "Memuat..." : "Cari" }}
                        </button>

                        <button
                            class="btn btn-sm btn-success"
                            @click="downloadExcel"
                            :disabled="isLoading"
                        >
                            <i class="fa fa-file-excel-o"></i> Download Excel
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="card mb-3">
            <div class="card-header text-white" :class="headerClass">
                {{ title }}
            </div>

            <div class="card-body table-card-body">
                <div class="datatable-responsive">
                    <div :id="tableId"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import initializeDataTable from "@/mixins/initializeTable";
import DropDownYear from "./DropDownYear.vue";

export default {
    name: "DataTable",

    components: {
        DropDownYear,
    },

    mixins: [initializeDataTable],

    props: {
        title: {
            type: String,
            required: true,
        },
        headerClass: {
            type: String,
            default: "bg-primary",
        },
        showFilter: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            isLoading: false,
        };
    },

    methods: {
        updateFilter(field, value) {
            const val =
                value?.target?.value !== undefined ? value.target.value : value;

            this.$set(this.filter, field, val);
        },
    },
};
</script>

<style scoped>
.table-card-body {
    overflow: hidden;
}

.datatable-responsive {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
}

.datatable-responsive :deep(.tabulator) {
    min-width: 1200px;
}

.datatable-responsive :deep(.tabulator-tableholder) {
    overflow-x: auto !important;
}

.global-loading-overlay {
    position: fixed;
    inset: 0;
    z-index: 999999;
    background: rgba(255, 255, 255, 0.65);
    display: flex;
    align-items: center;
    justify-content: center;
}

.global-loading-box {
    background: #fff;
    padding: 25px 35px;
    border-radius: 8px;
    box-shadow: 0 5px 20px rgba(0, 0, 0, 0.18);
    text-align: center;
}

.global-spinner {
    width: 42px;
    height: 42px;
    border: 4px solid #ddd;
    border-top-color: #0d6efd;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
    margin: 0 auto;
}

.global-loading-text {
    margin-top: 12px;
    font-weight: 600;
    color: #333;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

@media (max-width: 768px) {
    .datatable-responsive :deep(.tabulator) {
        min-width: 1000px;
        font-size: 11px;
    }

    .text-end {
        text-align: left !important;
    }
}
</style>
